<template>
    <b-container fluid id="subscription-agreement-content" v-if="code === 'flash'">
        <b-row v-for="(section, index) in content" :key="`subscription-agreement-${index}`">
            <b-col cols="12">
                <h5>{{ section.heading }}</h5>
                <p v-for="(paragraph, pIndex) in section.paragraphs"
                    :key="`section-paragraph-${pIndex}`"
                    v-html="paragraph">
                </p>
                <ol v-if="section.is_ol" class="px-0">
                    <li v-for="(ol, olIndex) in section.items" :key="`section-ol-${olIndex}`" class="mb-3">
                        <strong>{{ ol.heading }}</strong>
                        <ol v-if="ol.is_ol" class="my-2">
                            <li v-for="(subOl, subOlIndex) in ol.items" :key="`section-sub-ol-${subOlIndex}`" class="mb-3">
                                <span v-html="subOl.item"></span>
                                <ol v-if="subOl.is_ol" class="my-2">
                                    <li v-for="(subOl2, subOl2Index) in subOl.items" :key="`section-sub-ol-2-${subOl2Index}`" class="mb-3">
                                        <span v-html="subOl2.item"></span>
                                        <ol v-if="subOl2.is_ol" class="my-2">
                                            <li v-for="(subOl3, subOl3Index) in subOl2.items" :key="`section-sub-ol-3-${subOl3Index}`" class="mb-3">
                                                <span v-html="subOl3.item"></span>
                                                <ol v-if="subOl3.is_ol" class="my-2">
                                                    <li v-for="(subOl4, subOl4Index) in subOl3.items" :key="`section-sub-ol-3-${subOl4Index}`" class="mb-3">
                                                        <span v-html="subOl4.item"></span>
                                                        <ol v-if="subOl4.is_ol" class="my-2">
                                                            <li v-for="(subOl5, subOl5Index) in subOl4.items" :key="`section-sub-ol-3-${subOl5Index}`" class="mb-3">
                                                                <span v-html="subOl5.item"></span>
                                                                <ol v-if="subOl5.is_ol" class="my-2">
                                                                    <li v-for="(subOl6, subOl6Index) in subOl5.items" :key="`section-sub-ol-3-${subOl6Index}`" class="mb-3">
                                                                        <span v-html="subOl6.item"></span>
                                                                        <ol v-if="subOl6.is_ol" class="my-2">
                                                                            <li v-for="(subOl7, subOl7Index) in subOl6.items" :key="`section-sub-ol-3-${subOl7Index}`" class="mb-3">
                                                                                <span v-html="subOl7.item"></span>
                                                                            </li>
                                                                        </ol>
                                                                    </li>
                                                                </ol>
                                                            </li>
                                                        </ol>
                                                    </li>
                                                </ol>
                                            </li>
                                        </ol>
                                    </li>
                                </ol>
                                <table v-if="subOl.is_table" width="100%" border="1" style="margin-top: 10px; font-size: 14px;">
                                    <tr v-for="(tr, trIndex) in subOl.table" :key="`tr-${trIndex}`">
                                        <template v-for="(tableRow, tableRowIndex) in tr.items">
                                            <th v-if="tableRow.is_th" :key="`th-${tableRowIndex}`" :style="{
                                                'text-align': tableRow.is_centered ? 'center' : null,
                                                'padding': '5px'
                                            }">
                                                {{ tableRow.item }}
                                            </th>
                                            <td v-else-if="!tableRow.is_th"
                                                :key="`td-${tableRowIndex}`"
                                                :style="{
                                                    'text-align': tableRow.is_centered ? 'center' : null,
                                                    'font-style': tableRow.is_italic ? 'italic' : null,
                                                    'padding': '5px',
                                                    'color': '#87929D'
                                                }"
                                                :colspan="tableRow.size"
                                            >
                                                {{ tableRow.item }}
                                            </td>
                                        </template>
                                    </tr>
                                </table>
                            </li>
                        </ol>
                    </li>
                </ol>
            </b-col>
        </b-row>
    </b-container>

    <vue-pdf-embed v-else :source="base64"/>
</template>

<script>
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'
import SubscriptionAgreementPdf from 'raw-loader!./SubscriptionAgreementPdf.txt'
import notGlifeContent from './subscription.policy.json';
import glifeContent from './glife.subscription.agreement.json';

export default {
    components: {
        VuePdfEmbed
    },
    props: ['code'],
    data() {
        return {
            content: this.code === 'flash' ? glifeContent : notGlifeContent,
            base64: SubscriptionAgreementPdf
        }
    }
}
</script>

<style lang="scss">
#subscription-agreement-content {
    p.section-heading {
        font-family: 'SKModernistBold', sans-serif;
        font-size: 18px !important;
        line-height: 23px !important;
        color: #2F3941 !important;
    }
    ol {
        counter-reset: item;
        li {
            display: block;
            &:before {
                font-family: 'SKModernistBold', sans-serif;
                font-size: 14px;
                content: counters(item, ".") ". ";
                counter-increment: item;
            }
        }
    }
    span {
        font-size: 14px;
        line-height: 26px;
        color: #87929D;
        & > strong {
            color: #2F3941 !important;
        }
    }
    p,
    span {
        & > a {
            color: #FF830E;
        }
    }
}
</style>
